import { useState } from 'react'
import {
  formatarTelefone,
  normalizarTelefone,
  validarTelefone,
} from '@precad/compartilhado/validacao/telefone'
import { Campo } from '../componentes/Campo'

export const CAMPOS_CONTATO = ['telefone', 'whatsapp']

interface Props {
  dados: Record<string, string>
  aoAlterar: (campo: string, valor: string) => void
  aoVoltar: () => void
  aoAvancar: () => void
  ocupado: boolean
}

export function Contato({ dados, aoAlterar, aoVoltar, aoAvancar, ocupado }: Props) {
  const [erros, setErros] = useState<Record<string, string>>({})

  const mudar = (campo: string) => (valor: string) => {
    aoAlterar(campo, valor)
    if (erros[campo]) setErros((e) => ({ ...e, [campo]: '' }))
  }

  const formatarAoSair = (campo: string) => () => {
    const numero = normalizarTelefone(dados[campo] ?? '')
    if (validarTelefone(numero)) aoAlterar(campo, formatarTelefone(numero))
  }

  function validar(): boolean {
    const novos: Record<string, string> = {}
    const tel = normalizarTelefone(dados.telefone ?? '')
    if (!tel) novos.telefone = 'Informe um telefone.'
    else if (!validarTelefone(tel)) novos.telefone = 'Telefone inválido. Inclua o DDD.'

    /* WhatsApp é opcional, mas se veio preenchido tem de estar certo — o
       servidor DESCARTA número não conforme em silêncio, e a pessoa acharia
       que informou. */
    const zap = normalizarTelefone(dados.whatsapp ?? '')
    if (zap && !validarTelefone(zap)) novos.whatsapp = 'WhatsApp inválido. Inclua o DDD, ou deixe em branco.'

    setErros(novos)
    if (Object.keys(novos).length) {
      document.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus()
      return false
    }
    return true
  }

  return (
    <form
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
        if (validar()) aoAvancar()
      }}
    >
      <div className="grade grade--duas">
        <Campo
          rotulo="Telefone"
          valor={dados.telefone ?? ''}
          aoMudar={mudar('telefone')}
          aoSair={formatarAoSair('telefone')}
          erro={erros.telefone}
          tipo="tel"
          modo="tel"
          maxLength={16}
          autoComplete="tel"
          placeholder="(00) 00000-0000"
        />
        <Campo
          rotulo="WhatsApp"
          valor={dados.whatsapp ?? ''}
          aoMudar={mudar('whatsapp')}
          aoSair={formatarAoSair('whatsapp')}
          erro={erros.whatsapp}
          opcional
          tipo="tel"
          modo="tel"
          maxLength={16}
          placeholder="(00) 00000-0000"
          dica="Usamos só para agilizar contato sobre a análise."
        />
      </div>

      <p className="nota">
        O e-mail informado na primeira etapa <strong>{dados.email}</strong> continua sendo o canal
        oficial do pré-cadastro. Para alterá-lo, volte à etapa 1.
      </p>

      <div className="rodape">
        <button type="button" className="botao botao--secundario" onClick={aoVoltar}>
          Voltar
        </button>
        <span className="rodape__espaco" />
        <button type="submit" className="botao botao--principal" aria-disabled={ocupado}>
          {ocupado ? 'Salvando…' : 'Continuar'}
        </button>
      </div>
    </form>
  )
}
